// extracted by mini-css-extract-plugin
export default {"wrap":"wv1Wn","group":"RsHkZ","groupRow":"b3ZkQ","groupRowItem":"sLajn","label":"QAHNf","body":"W8xjf","submit":"ocpJi","restorePhoneError":"ytEj0","captchaWrap":"cdAGq"};